import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "list-group"
}
const _hoisted_2 = { class: "d-flex justify-content-start align-items-center" }
const _hoisted_3 = { class: "ms-4 line-height-1" }
const _hoisted_4 = { class: "text-primary" }
const _hoisted_5 = { class: "text-primary" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "d-flex justify-content-start align-items-center" }
const _hoisted_9 = { class: "ms-4 line-height-1" }
const _hoisted_10 = { class: "text-primary" }
const _hoisted_11 = {
  key: 0,
  class: "text-primary"
}
const _hoisted_12 = ["onClick"]
const _hoisted_13 = ["onClick"]
const _hoisted_14 = {
  key: 1,
  class: "text-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_user_image = _resolveComponent("user-image")!
  const _component_VueDraggableNext = _resolveComponent("VueDraggableNext")!

  return (_ctx.playlist.data.scenarios.length > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.userOwns)
          ? (_openBlock(), _createBlock(_component_VueDraggableNext, {
              key: 0,
              modelValue: _ctx.scenarios,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.scenarios) = $event)),
              onChange: _ctx.reorder
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.scenarios, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: "list-group-item d-flex justify-content-between align-items-center"
                  }, [
                    _createElementVNode("div", _hoisted_2, [
                      _cache[2] || (_cache[2] = _createElementVNode("i", { class: "fa fa-bars cursor-move" }, null, -1)),
                      _createVNode(_component_user_image, {
                        source: item.patient_image,
                        class: "ms-4"
                      }, null, 8, ["source"]),
                      _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("span", _hoisted_4, _toDisplayString(item.scenario.title), 1),
                        _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1)),
                        _createElementVNode("small", null, _toDisplayString(item.scenario.patient_name), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.status(item.status)), 1),
                    _createElementVNode("div", null, [
                      _createElementVNode("button", {
                        onClick: ($event: any) => (_ctx.view(item)),
                        class: "btn btn-sm btn-secondary me-2"
                      }, _cache[3] || (_cache[3] = [
                        _createElementVNode("i", { class: "fa fa-eye" }, null, -1)
                      ]), 8, _hoisted_6),
                      _createElementVNode("button", {
                        onClick: ($event: any) => (_ctx.remove(item.id,index)),
                        class: "btn btn-sm btn-danger"
                      }, _cache[4] || (_cache[4] = [
                        _createElementVNode("i", { class: "fa fa-trash" }, null, -1)
                      ]), 8, _hoisted_7)
                    ])
                  ]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue", "onChange"]))
          : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.scenarios, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "list-group-item d-flex justify-content-between align-items-center"
              }, [
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_user_image, {
                    source: item.patient_image
                  }, null, 8, ["source"]),
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("span", _hoisted_10, _toDisplayString(item.scenario.title), 1),
                    _cache[5] || (_cache[5] = _createElementVNode("br", null, null, -1)),
                    _createElementVNode("small", null, _toDisplayString(item.scenario.patient_name), 1)
                  ])
                ]),
                (_ctx.userOwns)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_ctx.status(item.status)), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("div", null, [
                  _createElementVNode("button", {
                    onClick: ($event: any) => (_ctx.view(item)),
                    class: "btn btn-sm btn-secondary me-2"
                  }, _cache[6] || (_cache[6] = [
                    _createElementVNode("i", { class: "fa fa-eye" }, null, -1)
                  ]), 8, _hoisted_12),
                  (_ctx.userOwns)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        onClick: ($event: any) => (_ctx.remove(item.id,index)),
                        class: "btn btn-sm btn-danger"
                      }, _cache[7] || (_cache[7] = [
                        _createElementVNode("i", { class: "fa fa-trash" }, null, -1)
                      ]), 8, _hoisted_13))
                    : _createCommentVNode("", true)
                ])
              ]))
            }), 128))
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_14, "You have no scenarios in this list"))
}